export type Listener<T> = (event: T) => void;

export class Emitter<T> {
  private listeners: Listener<T>[] = [];
  subscribe(listener: Listener<T>): () => void {
    this.listeners.push(listener);
    return () => {
      const idx = this.listeners.indexOf(listener);
      if (idx >= 0) this.listeners.splice(idx, 1);
    };
  }
  emit(event: T): void {
    const snapshot = this.listeners.slice();
    for (const l of snapshot) {
      // Isolate each listener — without this, the first listener to throw
      // synchronously terminates the for-loop and prevents every subsequent
      // listener from receiving the event. Symptom in the wild: the bridge's
      // UI handler for BetPlaced throws on some Phaser-side edge case (e.g.
      // chip-fly setup with N bets on the felt), and the session recorder,
      // which is registered AFTER the bridge in the listener list, never
      // sees BetPlaced. The wire shows only BankrollChanged (whose handler
      // doesn't throw) and spectators see broken state. Catching here keeps
      // every subscriber independent.
      try {
        l(event);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Emitter listener threw on event', event, err);
      }
    }
  }
}
